export const IS_DEMO_MODE = process.env.REACT_APP_DEMO_MODE === 'true';

export const DEMO_PORTFOLIO_URL = process.env.REACT_APP_PORTFOLIO_URL || '';
